import { Add } from "@mui/icons-material";
import EmptyList from "../EmptyList";

export default function EmptyMeals(){
    const msg = ["Add a new meal by clicking ", <Add key="add"/>]
    return <EmptyList title="No Meals" msg={msg}/>
}